import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const defaultHeigth = 60
const drawerWidth = 300
const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    backgroundColor: '#FFFFFF',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    heigth: '100%',
    maxWidth: contentMaxWidth,
    marginTop: '0.25rem',
    overflow: 'hidden',
  },

  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    fontFamily: 'Nunito !important',
  },

  headerMoreContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  userContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: `${defaultHeigth}px`,
    maxHeight: `${defaultHeigth}px`,
  },

  divisor: {
    width: '100%',
    height: '1px',
    backgroundColor: theme.palette.secondary.light,
  },
}))

export { useStyles }
